import {
  isSupportCenterEnabledForProfile,
  type SupportCenterProfile,
} from '@sdx/b2o-fe-tools/featureFlags';
import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';
import { useAuth } from '../../../core/contexts/AuthContext';
import { useGetData } from '../../../core/services/apiClient';
import { resolveSupportCenterAccess } from '../utils/resolveSupportCenterAccess';

export const useSupportCenterAccess = (): AccessDecision => {
  const { isFullyAuthenticated, flags, authError } = useAuth();
  const baseUrl = import.meta.env.VITE_FOUNDATION_API_BASE_URL as string;

  // Same URL + query key as useIsAliciaEnabled, so both read one cached /v1.0/profile response.
  const { data, isPending, isError } = useGetData<SupportCenterProfile>(
    { url: `${baseUrl}/v1.0/profile`, queryKey: 'languagePreference' },
    { enabled: isFullyAuthenticated },
  );

  // Flags still loading are not 'off' yet, but flags that failed to load (auth error, no flags) are a
  // final deny, not an endless wait. A profile read that failed with no data is a final deny; a failed
  // background refetch keeps the cached profile, which still decides.
  const flagsFailed = flags === null && authError != null;
  const profileFailed = isError && data === undefined;

  return resolveSupportCenterAccess({
    flagEnabled: !flagsFailed && (flags === null || flags.ENABLE_SUPPORT_CENTER === true),
    isChecking: flags === null || (isPending && !profileFailed),
    countryAllowed: !profileFailed && isSupportCenterEnabledForProfile(data, flags),
  });
};
